import * as React from 'react';
import {
    Button,
    Checkbox,
    Col,
    ControlLabel,
    FormGroup,
    Panel,
    PanelGroup,
    Row
} from 'react-bootstrap';
import { getSiteName, Zentuvo } from '../../shared/Site';
import { withRouter } from 'react-router-dom';
import Loader from 'react-loader';
import { connect } from 'react-redux';
import * as Features from '../../shared/Features';
import { Translate } from '../../shared/LanguageService';
import { handleError } from '../../shared/ErrorCatching';
import { assign } from '../../shared/Assign';
import * as bookingActions from '../photographerBooking/se360/actions/SE360PhotographerBookingActions';
import FormInputChangeHandler from '../../shared/form/FormInputChangeHandler';
import ValidatableFormGroup from '../../components/common/ValidatableFormGroup';
import FormSelect from '../../components/common/FormSelect';
import ICoordinate from '../../features/map/ICoordinate';
import CreateOrderOtherForm from './createOrder/v1/CreateOrderOtherForm';
import CreateOrderInvoiceReceiverForm from './createOrder/v1/CreateOrderInvoiceReceiverForm';
import CreateOrderAddressForm from './createOrder/v1/CreateOrderAddressForm';
import CreateOrderContactForm from './createOrder/v1/CreateOrderContactForm';
import AgreementModal from './AgreementModal';
import { BrokerAgreementDialog } from './brokerAgreement/BrokerAgreementDialog';
import { agreementToShow } from './brokerAgreement/agreementToShow';
import { resetsAgreementAcceptance } from './brokerAgreement/agreementAcceptanceAfterFirmChange';
import { ShownAgreement } from './brokerAgreement/types';
import {
    CustomerTypes,
    ICreateOrder,
    ICreateOrderAddress,
    ICreateOrderContact,
    ICreateOrderOther,
    IInvoiceReceiver,
    InvoiceBillingMethods,
    InvoiceReceiverTypes,
    InvoiceSellerStatus
} from './Entities';
import * as actions from './OrdersActions';
import _ from 'lodash';
import { BookingType } from './types/types';
import { getBookingType } from './utils/displayOrderButtonsUtil';
import { CreateOrderProductSelection } from './createOrder/v1/productSelection/view/CreateOrderProductSelection';
import { handleOrderCreated } from './utils/orderCreatedFlow';
import CreateOrderSelectPreferredDateForm from './createOrder/v1/CreateOrderSelectPreferredDateForm';
import { ORDER_INFORMATION_PANEL_ID } from '../../debug/orders/createOrder/v1/state/debugFiller';
import { getUserInfo } from '../../telemetry/utils';

interface IState {
    pickupDialogOpen: boolean;
    contentProviderId?: number;

    [x: string]: any;
}

class CloneOrderPage extends React.Component<any, IState> {
    formInputChangeHandler: FormInputChangeHandler;
    isZentuvoSite: boolean;

    constructor(props: any, context: any) {
        super(props, context);

        this.isZentuvoSite = window.appConfig.site === getSiteName(Zentuvo);

        this.state = {
            errors: {},
            order: {
                invoiceReceiver: {
                    receiver: 1,
                    invoiceBillingMethod: InvoiceBillingMethods.Email,
                    allowsSeparateBillingAddress: false,
                    separateBillingAddress: false,
                    sellerAgreementAccepted: false
                } as IInvoiceReceiver,
                address: { apartmentHasBalcony: false } as ICreateOrderAddress,
                contact: {} as ICreateOrderContact,
                other: {
                    willOrderCreatorAttendWhenPhotographing: false,
                    preferredTimeOfPhotographing: Date,
                    preferredTimeOfPhotographingSlot: '',
                    notes: ''
                } as ICreateOrderOther,
                products: [],
                agreementAccepted: true,
                pendingOrderId: null
            } as ICreateOrder,
            productsInitialized: false,
            showAgreementModal: false,
            agreementKey: -1,
            objectTypeLockDown: null,
            isAdressValid: false,
            selectedBrokerAgent: undefined,
            selectedBrokerFirm: undefined,
            shownAgreement: null,
            loaded: true,
            availableBrokerFirms: [],
            bookingClicked: false,
            notes: '',
            pickupDialogOpen: false,
            preferredDateOfPhotographing: null
        };

        this.createOrder = this.createOrder.bind(this);
        this.canPlaceOrder = this.canPlaceOrder.bind(this);
        this.setOrderState = this.setOrderState.bind(this);
        this.getAvailableBrokerFirms = this.getAvailableBrokerFirms.bind(this);
        this.preSelectBrokerAgent = this.preSelectBrokerAgent.bind(this);
        this.preSelectHeadQuarterFirm = this.preSelectHeadQuarterFirm.bind(this);
        this.getPackageProducts = this.getPackageProducts.bind(this);
        this.getStylingProducts = this.getStylingProducts.bind(this);
        this.getPlanProducts = this.getPlanProducts.bind(this);
        this.getAdditionalPackageProducts = this.getAdditionalPackageProducts.bind(this);
        this.onAgentChanged = this.onAgentChanged.bind(this);
        this.onAgentSelected = this.onAgentSelected.bind(this);
        this.onFirmChanged = this.onFirmChanged.bind(this);
        this.onFirmSelected = this.onFirmSelected.bind(this);
        this.onPackageProductClicked = this.onPackageProductClicked.bind(this);
        this.onAdditionalPackageProductClicked = this.onAdditionalPackageProductClicked.bind(this);
        this.onPlanProductClicked = this.onPlanProductClicked.bind(this);
        this.onInvoiceReceiverReceiverChange = this.onInvoiceReceiverReceiverChange.bind(this);
        this.onInvoiceBillingMethodChange = this.onInvoiceBillingMethodChange.bind(this);
        this.openBrokerAgreementModal = this.openBrokerAgreementModal.bind(this);
        this.openOwnerAgreementModal = this.openOwnerAgreementModal.bind(this);
        this.closeAgreementModal = this.closeAgreementModal.bind(this);
        this.updateReceiver = this.updateReceiver.bind(this);
        this.onPointChange = this.onPointChange.bind(this);
        this.canOpenOrderInfo = this.canOpenOrderInfo.bind(this);
        this.hasProductPropertyEditCustomerImages =
            this.hasProductPropertyEditCustomerImages.bind(this);
        this.onInvoiceReceiverOtherBrokerFirmChange =
            this.onInvoiceReceiverOtherBrokerFirmChange.bind(this);
        this.getAvailableBrokerAgents = this.getAvailableBrokerAgents.bind(this);
        this.formInputChangeHandler = new FormInputChangeHandler(
            this.state.order,
            this.setOrderState
        );
        this.onStylingProductClicked = this.onStylingProductClicked.bind(this);
        this.onShowcaseProductClicked = this.onShowcaseProductClicked.bind(this);
        this.updateAccordingToStylingProductSelection =
            this.updateAccordingToStylingProductSelection.bind(this);
        this.isStylingSelected = this.isStylingSelected.bind(this);
        this.onSelectionOfPreferredDate = this.onSelectionOfPreferredDate.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        let order = assign({}, this.state.order);

        if (nextProps.newOrder.existingOrderData && !this.state.pageInitialized) {
            let defaults = nextProps.newOrder.existingOrderData || {
                    contact: { ownerFirstName: '' }
                };
            order.contact = defaults.contact || {};
            order.address = defaults.address || {};

            this.setState({ pageInitialized: true });
        }

        if (nextProps.newOrder.availableProducts && !this.state.productsInitialized) {
            let products = nextProps.newOrder.availableProducts || [];
            products.map((x: any) => {
                x.available = x.productTypeType !== 3 && x.productTypeType !== 8;

                if (this.props.newOrder.selectedProducts.some(selectedProduct => selectedProduct.id === x.id)) {
                    x.selected = true;
                }
            });
            if (products.filter((x: any) => x.productTypeType === 2 && x.selected).length === 1) {
                this.updateAccordingToPackageProductSelection(
                    products,
                    products.filter((x: any) => x.productTypeType === 2 && x.selected)[0].id,
                    true
                );
            }
            order.products = assign([], products);
            this.setState({ productsInitialized: true });
        }

        this.setState({ order: order });
        this.formInputChangeHandler.updateObj(order);
    }

    componentDidMount(): void {
        let order = this.state.order;

        this.props.actions.clearAddressPointLocationForBooking();

        let pickupDialogOpen = false;
        this.props.actions
            .cloneOrder(this.props.match.params.orderId)
            .then(() => {
                this.preSelectBrokerAgentAndFirm();
            })
            .catch((error: any) => handleError(error));

        this.setState({ order: order, pickupDialogOpen: pickupDialogOpen });
    }

    get isCustomerAllowedToBook() {
        return this.state.selectedBrokerFirm
            ? this.state.selectedBrokerFirm.isCustomerAllowedToBook
            : false;
    }
    
    preSelectBrokerAgentAndFirm() {
        this.preSelectBrokerAgent();
        this.preSelectBrokerFirm();
    }

    preSelectBrokerAgent() {
        if (this.props.newOrder && this.props.newOrder.availableBrokerAgents.length > 0) {
            // New order
            if (this.props.user.details.role == "role/administrator") {
                this.onAgentSelected(this.props.newOrder.availableBrokerAgents[0].id);
            } else {
                this.onAgentSelected(this.props.user.details.id);
            }
        }

        if (this.state.selectedBrokerAgent) {
            this.setState({
                availableBrokerFirms: this.state.selectedBrokerAgent.availableBrokerFirms
            });
        }
    }

    preSelectBrokerFirm() {
        if (this.props.newOrder && this.props.newOrder.availableBrokerAgents.length > 0) {
            // New order
            this.preSelectHeadQuarterFirm();
        }
    }

    selectBrokerAgent() {
        if (this.props.newOrder && this.props.newOrder.availableBrokerAgents.length > 0) {
            // New order
            if (this.props.user.details.role == "role/administrator") {
                this.onAgentSelected(this.props.newOrder.availableBrokerAgents[0].id);
            } else {
                this.onAgentSelected(this.props.user.details.id);
            }
        }
    }

    hasProductPropertyEditCustomerImages() {
        return this.state.order.products.some(
            (x) => x.selected && x.hasProductPropertyEditCustomerImages
        );
    }    

    preSelectHeadQuarterFirm() {
        let availableFirms = assign([], this.state.availableBrokerFirms);
        if (availableFirms.length > 0) {
            let brokerFirmId = availableFirms.filter((x: any) => x.isHeadQuarter)[0].id;
            this.onFirmSelected(brokerFirmId);
        }
    }

    onInvoiceReceiverReceiverChange(e) {
        this.updateReceiver(e.target.name, parseInt(e.target.value));
    }

    updateReceiver(targetName, receiverId) {
        const { selectedBrokerFirm } = this.state;
        const isCommercial =
            selectedBrokerFirm && selectedBrokerFirm.customerType === CustomerTypes.Commercial;

        let order = assign({}, this.state.order);
        let invoiceReceiver = this.props.newOrder.availablePrivateInvoiceReceiverTypes
            .concat(this.props.newOrder.availableCommercialInvoiceReceiverTypes)
            .find((x) => x.id === receiverId);

        if (
            this.state.selectedBrokerFirm.invoiceSellerStatus === InvoiceSellerStatus.Mandatory ||
            !isCommercial
        ) {
            order.invoiceReceiver.allowsSeparateBillingAddress = false;
            order.invoiceReceiver.separateBillingAddress = false;
            order.invoiceReceiver.otherBrokerFirm = null;
            order.invoiceReceiver.invoiceBillingMethod = InvoiceBillingMethods.Email;
        } else {
            order.invoiceReceiver.allowsSeparateBillingAddress = invoiceReceiver
                ? invoiceReceiver.allowsSeparateBillingAddress
                : false;

            if (
                !this.state.isPackageOrder &&
                receiverId === InvoiceReceiverTypes.Seller &&
                isCommercial
            ) {
                order.invoiceReceiver.separateBillingAddress = true;
            }

            if (receiverId === InvoiceReceiverTypes.OtherCompany) {
                order.invoiceReceiver.otherBrokerFirm = this.getAvailableBrokerFirms().filter(
                    (x: any) => x.id !== this.state.selectedBrokerFirm.id
                )[0].id;
            } else {
                order.invoiceReceiver.otherBrokerFirm = null;
            }
        }
        this.formInputChangeHandler.updateObj(order);
        this.formInputChangeHandler.handleChange(targetName, receiverId);
    }

    onInvoiceReceiverOtherBrokerFirmChange(e) {
        this.formInputChangeHandler.onChange(e);
    }

    onInvoiceBillingMethodChange(e) {
        this.formInputChangeHandler.onChange(e);
    }

    getAvailableBrokerFirms() {
        if (this.state.availableBrokerFirms.length > 0) {
            return this.state.availableBrokerFirms;
        }
        return [];
    }

    getAvailableBrokerAgents() {
        if (
            this.props.newOrder &&
            this.state.selectedBrokerFirm &&
            this.props.newOrder.availableBrokerAgents.length > 0
        ) {
            let agents = [...this.props.newOrder.availableBrokerAgents];
            let filteredAgents = agents.filter((a) =>
                this.agentPartOfFirm(a, this.state.selectedBrokerFirm.id)
            );
            return filteredAgents;
        }
        return [];
    }

    agentPartOfFirm(agent: any, firmId: number): boolean {
        let returnValue = false;
        agent.availableBrokerFirms.forEach((firm) => {
            if (firm.id === firmId) {
                returnValue = true;
            }
        });
        return returnValue;
    }

    updateAccordingToPackageProductSelection(products: any, id: number, selected: boolean) {
        let isPackageOrder = selected;
        let clickedProduct = products
            .filter((x: any) => x.productTypeType === 2)
            .filter((x: any) => x.id === id)[0];
        let otherPackageAndStylingProducts = products
            .filter((x: any) => x.productTypeType === 7 || x.productTypeType === 2)
            .filter((x: any) => x.id !== id);
        clickedProduct.selected = selected;

        if (!selected) {
            for (let x of otherPackageAndStylingProducts) {
                x.available = true;
            }
        } else {
            for (let x of otherPackageAndStylingProducts) {
                x.selected = false;
                x.available = false;
            }
        }
        let showcaseProduct = products.filter(
            (x: any) => x.productTypeType === 8 && !x.isStylingProduct
        );
        for (let x of showcaseProduct) {
            x.available = selected;
        }

        let additionalPackageProducts = products.filter(
            (x: any) => x.productTypeType === 3 && !x.isStylingProduct
        );
        for (let x of additionalPackageProducts) {
            x.available = selected;
        }

        let objectTypeLockDown = clickedProduct.selected ? clickedProduct.lockObjectTypeTo : null;
        if (objectTypeLockDown && this.state.order && this.state.order.address) {
            let order = this.state.order;

            let address = this.state.order.address;
            address.objectType = objectTypeLockDown.value;
            order.address = assign({}, address);

            this.setState({ order: assign({}, order) });
        }

        this.setState({ isPackageOrder, objectTypeLockDown });
    }

    updateAccordingToStylingProductSelection(products: any, id: number, selected: boolean) {
        let isPackageOrder = selected;
        let clickedProduct = products
            .filter((x: any) => x.productTypeType === 7)
            .filter((x: any) => x.id === id)[0];
        let otherPackageAndStylingProducts = products
            .filter((x: any) => x.productTypeType === 7 || x.productTypeType === 2)
            .filter((x: any) => x.id !== id);
        let showCaseProduct = products
            .filter((x: any) => x.productTypeType === 8)
            .filter((x: any) => x.id !== id);
        clickedProduct.selected = selected;

        if (!selected) {
            for (let x of otherPackageAndStylingProducts) {
                x.available = true;
            }
        } else {
            for (let x of otherPackageAndStylingProducts) {
                x.selected = false;
                x.available = false;
            }
            for (let x of showCaseProduct) {
                x.available = false;
                x.selected = false;
            }
        }

        products
            .filter((x: any) => {
                return x.productTypeType === 3;
            })
            .map((x: any) => {
                if (x.isStylingProduct) {
                    x.available = selected;
                } else {
                    x.selected = false;
                    x.available = false;
                }
            });

        let objectTypeLockDown = clickedProduct.selected ? clickedProduct.lockObjectTypeTo : null;
        if (objectTypeLockDown && this.state.order && this.state.order.address) {
            let order = this.state.order;

            let address = this.state.order.address;
            address.objectType = objectTypeLockDown.value;
            order.address = assign({}, address);

            this.setState({ order: assign({}, order) });
        }

        this.setState({ isPackageOrder, objectTypeLockDown });
    }

    onPlanProductClicked(id: number) {
        let order = this.state.order;
        let products = this.state.order.products;
        let clickedProduct = products.filter((x: any) => x.id === id)[0];

        if (!clickedProduct.required) {
            clickedProduct.selected = !clickedProduct.selected;
        }

        products
            .filter((x) => x.hasProductPropertyMeasured)
            .forEach((measuredProduct) => {
                measuredProduct.selected = measuredProduct.selected || measuredProduct.required;
            });

        order.products = assign([], products);
        this.setState({ order: order });
        this.formInputChangeHandler.updateObj(order);
    }

    onPackageProductClicked(id: number) {
        let order = this.state.order;
        let products = this.state.order.products;
        let clickedProduct = products.filter((x: any) => x.id === id)[0];

        if (clickedProduct.available && !clickedProduct.required) {
            this.updateAccordingToPackageProductSelection(products, id, !clickedProduct.selected);
            order.products = assign([], products);
            this.setState({ order: order });
            this.formInputChangeHandler.updateObj(order);
        }
    }

    onDigitalStylingProductClicked = (id: number) => {
        let { order } = this.state;

        this.setState(
            {
                order: {
                    ...order,
                    products: order.products.map((product: any) => {
                        if (product.id === id && !product.required) {
                            return {
                                ...product,
                                selected: !product.selected
                            };
                        }

                        return product;
                    })
                }
            },
            () => {
                this.formInputChangeHandler.updateObj(this.state.order);
            }
        );
    };

    onStylingProductClicked(id: number) {
        let order = this.state.order;
        let products = this.state.order.products;
        let clickedProduct = products.filter((x: any) => x.id === id)[0];

        if (clickedProduct.available && !clickedProduct.required) {
            this.updateAccordingToStylingProductSelection(products, id, !clickedProduct.selected);
            order.products = assign([], products);
            this.setState({ order: order });
            this.formInputChangeHandler.updateObj(order);
        }
    }

    onShowcaseProductClicked(id: number) {
        let order = this.state.order;
        let products = this.state.order.products;
        let clickedProduct = products.filter((x: any) => x.id === id)[0];

        if (clickedProduct.available && !clickedProduct.required) {
            clickedProduct.selected = !clickedProduct.selected;
            order.products = assign([], products);
            this.setState({ order: order });
            this.formInputChangeHandler.updateObj(order);
        }
    }

    updatePlanProductSelection = () => {
        let { products } = this.state.order;
        let planProducts = products.filter((x: any) => x.productTypeType === 1);

        let hasAnySelectedPlanProducts = planProducts.some((p: any) => p.selected);
        if (!hasAnySelectedPlanProducts) {
            planProducts[0].selected = true;
        }
    };

    onAdditionalPackageProductClicked(id: number) {
        let order = this.state.order;
        let products = this.state.order.products;
        let clickedProduct = products.filter((x: any) => x.id === id)[0];

        if (clickedProduct.available && !clickedProduct.required) {
            clickedProduct.selected = !clickedProduct.selected;

            if (clickedProduct.hasProductPropertyMeasured) {
                this.updatePlanProductSelection();
            }

            order.products = assign([], products);
            this.setState({ order: order });
            this.formInputChangeHandler.updateObj(order);
        }
    }

    getPackageProducts(): any {
        return this.state.order.products.filter((x: any) => x.productTypeType === 2);
    }

    getStylingProducts(): any {
        return this.state.order.products.filter((x: any) => x.productTypeType === 7);
    }

    getDigitalStylingProducts = () => {
        let { order } = this.state;
        return order.products.filter((product) => product.productTypeType === 9);
    };

    getShowcaseProducts(): any {
        return this.state.order.products.filter((x: any) => x.productTypeType === 8);
    }

    getPlanProducts(): any {
        return this.state.order.products.filter((x: any) => x.productTypeType === 1);
    }

    getAdditionalPackageProducts(): any {
        return this.state.order.products.filter((x: any) => x.productTypeType === 3);
    }

    canPlaceOrder(): boolean {
        return (
            this.state.order.agreementAccepted &&
            this.state.order.products.filter((x: any) => x.available && x.selected).length > 0
        );
    }

    isStylingSelected(): boolean {
        return (
            this.state.order.products.filter((x: any) => x.productTypeType == 7 && x.selected)
                .length > 0
        );
    }

    isShowcaseSelected(): boolean {
        return (
            this.state.order.products.filter((x: any) => x.productTypeType == 8 && x.selected)
                .length > 0
        );
    }

    isDuskPhotographySelected(): boolean {
        return (
            this.state.order.products.filter(
                (product: any) => product.hasProductPropertyDuskPhotography && product.selected
            ).length > 0
        );
    }

    canOpenOrderInfo(): boolean {
        return (
            this.state.order.products.filter(
                (x: any) =>
                    (x.productTypeType === 2 ||
                        x.productTypeType === 1 ||
                        x.productTypeType === 7 ||
                        x.productTypeType === 9) &&
                    x.selected
            ).length > 0
        );
    }

    shouldShowPreferredDateFormForProductType() {
        return (
            this.state.order.products.filter(
                (x: any) =>
                    (x.productTypeType === 2 ||
                        x.productTypeType === 3 ||
                        x.productTypeType == 7) &&
                    x.selected
            ).length > 0
        );
    }

    onAgentChanged(e: any) {
        this.onAgentSelected(parseInt(e.target.value));
    }

    onAgentSelected(agentId: number) {
        let selectedBrokerAgent = this.props.newOrder.availableBrokerAgents.filter(
            (a: any) => a.id === agentId
        );
        let order = assign({}, this.state.order);

        this.setState({
            selectedBrokerAgent:
                selectedBrokerAgent.length > 0 ? selectedBrokerAgent[0] : undefined,
            order: order,
            productsInitialized: false
        });

        this.formInputChangeHandler.updateObj(order);
    }

    onFirmChanged(e: any) {
        let brokerFirmId = parseInt(e.target.value);
        this.onFirmSelected(brokerFirmId);
    }

    onFirmSelected(firmId: number) {
        this.selectBrokerAgent();
        let selectedBrokerFirm = this.state.availableBrokerFirms.filter(
            (a: any) => a.id === firmId
        );
        let order = assign({}, this.state.order);

        let receiver: any;
        if (selectedBrokerFirm && selectedBrokerFirm[0].customerType === CustomerTypes.Commercial) {
            receiver = this.props.newOrder.availableCommercialInvoiceReceiverTypes.filter(
                (x: any) =>
                    x.id !== InvoiceReceiverTypes.OtherCompany ||
                    this.getAvailableBrokerFirms().filter(
                        (x: any) => x.id !== selectedBrokerFirm[0].id
                    ).length > 0
            )[0];
        } else if (
            selectedBrokerFirm[0].invoiceSellerStatus === InvoiceSellerStatus.Mandatory ||
            selectedBrokerFirm[0].invoiceSellerStatus === InvoiceSellerStatus.Show
        ) {
            receiver = this.props.newOrder.availablePrivateInvoiceReceiverTypes.filter(
                (x: any) => x.id === InvoiceReceiverTypes.Seller
            )[0];
        } else {
            receiver = this.props.newOrder.availablePrivateInvoiceReceiverTypes.filter(
                (x: any) =>
                    x.id !== InvoiceReceiverTypes.OtherCompany ||
                    this.getAvailableBrokerFirms().filter(
                        (x: any) => x.id !== selectedBrokerFirm[0].id
                    ).length > 0
            )[0];
        }
        order.invoiceReceiver.receiver = receiver.id;
        const agreementMustBeAcceptedAgain = resetsAgreementAcceptance(
            this.state.selectedBrokerFirm ? this.state.selectedBrokerFirm.id : undefined,
            firmId
        );
        if (agreementMustBeAcceptedAgain) {
            order.agreementAccepted = false;
        }
        this.setState(
            {
                order: order,
                shownAgreement: agreementMustBeAcceptedAgain ? null : this.state.shownAgreement,
                selectedBrokerFirm:
                    selectedBrokerFirm.length > 0 ? selectedBrokerFirm[0] : undefined
            },
            () => this.updateReceiver('invoiceReceiver.receiver', receiver.id)
        );
        this.formInputChangeHandler.updateObj(order);
        this.props.actions.getAvailableProducts(firmId);
    }

    openBrokerAgreementModal(): void {
        var state = _.merge({}, this.state);

        state.showAgreementModal = true;
        state.agreementKey =
            this.state.order.products.filter(
                (x: any) =>
                    x.available &&
                    x.selected &&
                    x.productTypeType !== this.props.newOrder.planOrderTypeValue
            ).length > 0
                ? this.props.brokerAgreementKey
                : this.props.planOnlyBrokerAgreementKey;

        this.setState(state);
    }

    openOwnerAgreementModal(): void {
        var state = _.merge({}, this.state);

        state.showAgreementModal = true;
        state.agreementKey = this.props.newOrder.ownerAgreementKey;

        this.setState(state);
    }

    rememberShownAgreement = (shownAgreement: ShownAgreement) => {
        this.setState({ shownAgreement });
    };

    renderAgreement() {
        const agreement = agreementToShow({
            agreementKey: this.state.agreementKey,
            brokerAgreementKey: this.props.brokerAgreementKey,
            planOnlyBrokerAgreementKey: this.props.planOnlyBrokerAgreementKey,
            selectedBrokerAgent: this.state.selectedBrokerAgent,
            selectedBrokerFirm: this.state.selectedBrokerFirm
        });

        return agreement.kind === 'broker-firm' ? (
            <BrokerAgreementDialog
                brokerAgentId={agreement.brokerAgentId}
                brokerFirmId={agreement.brokerFirmId}
                planOnly={agreement.planOnly}
                onClose={this.closeAgreementModal}
                onShown={this.rememberShownAgreement}
            />
        ) : (
            <AgreementModal
                agreementKey={agreement.agreementKey}
                close={this.closeAgreementModal}
            />
        );
    }

    closeAgreementModal(): void {
        var state = _.merge({}, this.state);

        state.showAgreementModal = false;
        state.AgreementKey = -1;

        this.setState(state);
    }

    onPointChange(position: ICoordinate) {
        this.formInputChangeHandler.handleChange('address.addressPointLocation', position);
    }

    setOrderState(order: any) {
        this.setState({ order: order }, () => {});
        this.formInputChangeHandler.updateObj(order);
    }

    createOrder(bookingType: BookingType, preferredDateOfPhotographing?: Date) {
        let { logger, user } = this.props;
        const bookDirectly = bookingType === BookingType.CustomerBookableOrder;

        this.setState({
            loaded: false,
            bookingClicked: true
        });

        let orderCommand = assign({}, this.state.order);

        orderCommand.products = orderCommand.products
            .filter((x: any) => x.available && x.selected)
            .map((x: any) => x.id);

        orderCommand.brokerAgentId = this.state.selectedBrokerAgent.id;
        orderCommand.brokerFirmId = this.state.selectedBrokerFirm.id;
        orderCommand.shownAgreement = this.state.shownAgreement;
        orderCommand.bookDirectly = bookDirectly;
        orderCommand.orderCollectionId = null;
        orderCommand.contact.ownerEmailAddress = orderCommand.contact.ownerEmailAddress
            ? orderCommand.contact.ownerEmailAddress.trim()
            : '';
        orderCommand.other.notes = new Array(orderCommand.other.notes || '', this.state.notes).join(
            '\n'
        );

        if (preferredDateOfPhotographing) {
            orderCommand.other.preferredTimeOfPhotographing = preferredDateOfPhotographing;
        }
        // used in CreateOrder.cs->CreateOrderInternal.cs->NewOrder.cs to get `availableBrokerAgents`
        orderCommand.CloneFromOrder = this.props.match.params.orderId; 

        if (!bookDirectly) {
            this.props.actions
                .createOrder(orderCommand, this.state.orderCollectionId)
                .then((createOrderResult: any) => {
                    this.setState({ loaded: true });
                    handleOrderCreated(bookingType, createOrderResult, this.props.history);
                })
                .catch((error: any) =>
                    handleError(error, (errors: any): void => {
                        this.setState({ errors: errors });
                        this.setState({ loaded: true });
                    })
                );
        } else {
            this.props.actions
                .createOrder(orderCommand, this.state.orderCollectionId, true)
                .then(async () => {
                    this.props.actions.saveOrderCommandForBooking(orderCommand);
                    this.props.actions.saveAddressPointLocationForBooking(
                        orderCommand.address.addressPointLocation
                    );
                    this.setState({ loaded: true });

                    let {
                        order: { address }
                    } = this.state;

                    let routeParams: any = {
                        pathname: '/se360/photographerbooking',
                        query: {
                            date: orderCommand.other.preferredTimeOfPhotographing,
                            city: address.addressCity,
                            street: address.addressLine1,
                            zip: address.addressPostalNumber
                        }
                    };

                    if (this.isStylingSelected()) {
                        routeParams = {
                            pathname: '/se360/stylingbooking',
                            query: {
                                date: orderCommand.other.preferredTimeOfPhotographing
                            }
                        };
                    }

                    if (this.isDuskPhotographySelected()) {
                        routeParams = {
                            pathname: '/se360/duskphotographybooking'
                        };
                    }
                    this.props.history.push(routeParams);
                })
                .catch((err: any) => {
                    logger.logException(err, {
                        origin: 'CreateOrderPage.createOrder',
                        userInfo: getUserInfo(user)
                    });

                    handleError(err, (errors: any): void => {
                        this.setState({ errors });
                        this.setState({ loaded: true });
                    });
                });
        }
    }

    getCreateOrderButtonLabel(bookingType: BookingType): string {
        switch (bookingType) {
            case BookingType.CustomerBookableOrder:
                return Translate('orders/create/button-label/book-directly'); //'Book now'|"Boka direkt"
            case BookingType.NonBookableOrder:
                return Translate('orders/create/button-label/create-order-plan'); //"Skapa order"
            case BookingType.AdminBookableOrder:
                return Translate('orders/create/button-label/create-order'); //'Send booking request'|"Skicka bokningsförfrågan"
            default:
                throw new Error(`Unknown BookingType: ${bookingType}`);
        }
    }

    onSelectionOfPreferredDate = (date: Date) => {
        this.setState({ preferredDateOfPhotographing: date });
    };

    showPrices = () => {
        return this.state.order.products.length > 0
            ? this.state.order.products[0].priceBrokerFirm
            : 0;
    };

    isPackageProductSelected = () => {
        return (
            this.state.order.products.filter((x: any) => x.productTypeType == 2 && x.selected)
                .length > 0
        );
    };

    calculatedTotalCost = () => {
        let selectedProducts = this.state.order.products;
        let currentTotalCost = 0;

        selectedProducts.forEach((element) => {
            if (element.selected === true && this.isPackageProductSelected() === true) {
                currentTotalCost += element.priceBrokerFirm ? element.priceBrokerFirm.value : 0;
            } else if (element.selected === true) {
                if (element.productTypeType !== 3) {
                    currentTotalCost += element.priceBrokerFirm ? element.priceBrokerFirm.value : 0;
                }
            }
        });
        return currentTotalCost;
    };

    showCurrencySign = () => {
        return this.state.order.products.length > 0
            ? this.state.order.products[0].currencySign
            : '';
    };

    render() {
        const bookingType = getBookingType(
            this.state.order.products,
            this.state.isPackageOrder,
            this.isCustomerAllowedToBook
        );

        const handleOnClickCreateOrder = () => {
            if (bookingType === BookingType.CustomerBookableOrder) {
                this.createOrder(bookingType);
            } else {
                this.createOrder(bookingType, this.state.preferredDateOfPhotographing);
            }
        };

        const displayFirmSelect = this.state.availableBrokerFirms.length > 1;
        const displayBrokerSelect = Features.hasFeature(
            Features.AssistCreateOrder,
            this.props.user
        );

        const { selectedBrokerFirm } = this.state;
        const displayInvoiceReceiverForm =
            selectedBrokerFirm &&
            (selectedBrokerFirm.invoiceSellerStatus === InvoiceSellerStatus.Show ||
                selectedBrokerFirm.invoiceSellerStatus === InvoiceSellerStatus.Mandatory);

        const { newOrder } = this.props;
        const availableInvoiceBillingMethods =
            selectedBrokerFirm &&
            (selectedBrokerFirm.invoiceSellerStatus === InvoiceSellerStatus.Mandatory ||
                selectedBrokerFirm.invoiceSellerStatus === InvoiceSellerStatus.Show)
                ? newOrder.availableInvoiceBillingMethods.filter(
                      (method: any) => method.id === InvoiceBillingMethods.Email
                  )
                : newOrder.availableInvoiceBillingMethods;

        const isCommercial =
            selectedBrokerFirm && selectedBrokerFirm.customerType === CustomerTypes.Commercial;

        return (
            <div>
                <h1>{Translate('orders/create/title/clone-order')}</h1>
                <PanelGroup
                        id="create-order-panel-group"
                        accordion
                        defaultActiveKey={displayBrokerSelect || displayFirmSelect ? '1' : '2'}
                    >
                    {(displayBrokerSelect || displayFirmSelect) && (
                        <Panel eventKey="1" className="agent-firm-selection-panel expand-icon">
                            <Panel.Heading>
                                <Panel.Title toggle>
                                    {Translate(
                                        'orders/create/panel-headings/select-agent-firm'
                                    )}
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible>
                                <Row>
                                    <form>
                                        {displayBrokerSelect && (
                                            <Col xs={12} sm={6}>
                                                <FormGroup className="required">
                                                    <ControlLabel>
                                                        {Translate(
                                                            'orders/create/form/order-agent-selection'
                                                        )}
                                                    </ControlLabel>
                                                    <FormSelect
                                                        autoFocus={true}
                                                        name="orderAgent"
                                                        value={
                                                            this.state.selectedBrokerAgent
                                                                ? this.state.selectedBrokerAgent
                                                                        .id
                                                                : undefined
                                                        }
                                                        onChange={this.onAgentChanged}
                                                    >
                                                        {this.getAvailableBrokerAgents().map(
                                                            (x: any) => (
                                                                <option value={x.id} key={x.id}>
                                                                    {x.name}
                                                                </option>
                                                            )
                                                        )}
                                                    </FormSelect>
                                                </FormGroup>
                                            </Col>
                                        )}
                                        {displayFirmSelect && (
                                            <Col xs={12} sm={6}>
                                                <FormGroup className="required">
                                                    <ControlLabel>
                                                        {Translate(
                                                            'orders/create/form/order-firm-selection'
                                                        )}
                                                    </ControlLabel>
                                                    <FormSelect
                                                        autoFocus={Features.hasFeature(
                                                            Features.AssistCreateOrder,
                                                            this.props.user
                                                        )}
                                                        name="orderFirm"
                                                        value={
                                                            selectedBrokerFirm
                                                                ? selectedBrokerFirm.id
                                                                : undefined
                                                        }
                                                        onChange={this.onFirmChanged}
                                                    >
                                                        {this.state.availableBrokerFirms
                                                            .filter((x: any) => x.isHeadQuarter)
                                                            .map((x: any) => (
                                                                <option value={x.id} key={x.id}>
                                                                    {x.name +
                                                                        ' (' +
                                                                        Translate(
                                                                            'orders/create/form/head-office'
                                                                        ) +
                                                                        ')'}{' '}
                                                                </option>
                                                            ))}
                                                        {this.state.availableBrokerFirms
                                                            .filter(
                                                                (x: any) => !x.isHeadQuarter
                                                            )
                                                            .map((x: any) => (
                                                                <option value={x.id} key={x.id}>
                                                                    {x.name}
                                                                </option>
                                                            ))}
                                                    </FormSelect>
                                                </FormGroup>
                                            </Col>
                                        )}
                                    </form>
                                </Row>
                            </Panel.Body>
                        </Panel>
                    )}
                    <CreateOrderProductSelection
                        additionalProducts={this.getAdditionalPackageProducts()}
                        calculatedTotalCost={this.calculatedTotalCost()}
                        currencySign={this.showCurrencySign()}
                        digitalStylingProducts={this.getDigitalStylingProducts()}
                        existingOrderData={this.props.newOrder.existingOrderData}
                        onClickAdditionalProduct={this.onAdditionalPackageProductClicked}
                        onClickDigitalStylingProduct={this.onDigitalStylingProductClicked}
                        onClickPackageProduct={this.onPackageProductClicked}
                        onClickPlanProduct={this.onPlanProductClicked}
                        onClickStylingProduct={this.onStylingProductClicked}
                        onClickShowcaseProduct={this.onShowcaseProductClicked}
                        packageProducts={this.getPackageProducts()}
                        pendingOrder={null}
                        planProducts={this.getPlanProducts()}
                        showPrices={this.showPrices()}
                        stylingProducts={this.getStylingProducts()}
                        showcaseProducts={this.getShowcaseProducts()}
                    />
                    {this.canOpenOrderInfo() && (
                        <Panel eventKey="3" className="expand-icon">
                            <Panel.Heading>
                                <Panel.Title id={ORDER_INFORMATION_PANEL_ID} toggle>
                                    {Translate('orders/create/panel-headings/order-info-form')}
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible>
                                <Row>
                                    <Col xs={12} sm={6}>
                                        {(
                                            this.isZentuvoSite || 
                                            (this.state.selectedBrokerFirm && this.state.selectedBrokerFirm.invoiceSellerStatus === InvoiceSellerStatus.Hidden)
                                            )
                                            ? (this.state.isPackageOrder || this.isStylingSelected()) &&
                                                !this.hasProductPropertyEditCustomerImages() && (
                                                <CreateOrderContactForm
                                                    contact={this.state.order.contact}
                                                    errors={this.state.errors}
                                                    isFormValid={() => true}
                                                    onDataChange={
                                                        this.formInputChangeHandler.onChange
                                                    }
                                                    isCommercial={isCommercial}
                                                    areContactNamesRequired={false}
                                                />
                                            )
                                            : (
                                                <CreateOrderContactForm
                                                    contact={this.state.order.contact}
                                                    errors={this.state.errors}
                                                    isFormValid={() => true}
                                                    onDataChange={
                                                        this.formInputChangeHandler.onChange
                                                    }
                                                    isCommercial={isCommercial}
                                                    areContactNamesRequired={true}
                                                />
                                            )
                                        }

                                        <CreateOrderAddressForm
                                            address={this.state.order.address}
                                            availablePrivateObjectTypes={
                                                this.props.newOrder.availablePrivateObjectTypes
                                            }
                                            availableCommercialObjectTypes={
                                                this.props.newOrder
                                                    .availableCommercialObjectTypes
                                            }
                                            errors={this.state.errors}
                                            isFormValid={() => true}
                                            onDataChange={this.formInputChangeHandler.onChange}
                                            isPackageOrder={
                                                (this.state.isPackageOrder ||
                                                    this.isStylingSelected()) &&
                                                !this.hasProductPropertyEditCustomerImages()
                                            }
                                            objectTypeLockDown={this.state.objectTypeLockDown}
                                            isCommercial={isCommercial}
                                            onPointChange={this.onPointChange}
                                            onCustomChange={
                                                this.formInputChangeHandler.handleChange
                                            }
                                        />
                                    </Col>
                                    {displayInvoiceReceiverForm && (
                                        <Col xs={12} sm={6}>
                                            <CreateOrderInvoiceReceiverForm
                                                errors={this.state.errors}
                                                availablePrivateInvoiceReceiverTypes={
                                                    newOrder.availablePrivateInvoiceReceiverTypes
                                                }
                                                availableCommercialInvoiceReceiverTypes={
                                                    newOrder.availableCommercialInvoiceReceiverTypes
                                                }
                                                availableInvoiceBillingMethods={
                                                    availableInvoiceBillingMethods
                                                }
                                                availableOtherToInvoice={this.getAvailableBrokerFirms().filter(
                                                    (x: any) => x.id !== selectedBrokerFirm.id
                                                )}
                                                isFormValid={() => true}
                                                onDataChange={
                                                    this.formInputChangeHandler.onChange
                                                }
                                                onInvoiceReceiverReceiverChange={
                                                    this.onInvoiceReceiverReceiverChange
                                                }
                                                onInvoiceBillingMethodChange={
                                                    this.onInvoiceBillingMethodChange
                                                }
                                                onInvoiceReceiverOtherBrokerFirmChange={
                                                    this.onInvoiceReceiverOtherBrokerFirmChange
                                                }
                                                invoiceSellerStatus={
                                                    selectedBrokerFirm.invoiceSellerStatus
                                                }
                                                invoiceReceiver={
                                                    this.state.order.invoiceReceiver
                                                }
                                                isPackageOrder={this.state.isPackageOrder}
                                                isCommercial={isCommercial}
                                                openAgreementModal={
                                                    this.openOwnerAgreementModal
                                                }
                                            />
                                        </Col>
                                    )}
                                </Row>
                                {this.shouldShowPreferredDateFormForProductType() &&
                                !this.isCustomerAllowedToBook ? (
                                    <Row>
                                        <Col xs={12}>
                                            <CreateOrderSelectPreferredDateForm
                                                other={this.state.order.other}
                                                onChange={this.onSelectionOfPreferredDate}
                                                onDataChange={
                                                    this.formInputChangeHandler.onChange
                                                }
                                                errors={this.state.errors}
                                            />
                                        </Col>
                                    </Row>
                                ) : null}
                                <Row>
                                    <Col xs={12}>
                                        <CreateOrderOtherForm
                                            other={this.state.order.other}
                                            availableContactPersons={
                                                this.props.newOrder.availableContactPersons
                                            }
                                            errors={this.state.errors}
                                            isFormValid={() => true}
                                            onDataChange={this.formInputChangeHandler.onChange}
                                            onPreferredTimeOfPhotographingDateChange={() => {}}
                                            isPackageOrder={
                                                (this.state.isPackageOrder ||
                                                    this.isStylingSelected()) &&
                                                !this.hasProductPropertyEditCustomerImages()
                                            }
                                            isStylingOrder={this.isStylingSelected()}
                                            isCommercial={isCommercial}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col
                                        xs={12}
                                        className="align-right vertical-middle compensate"
                                    >
                                        <ValidatableFormGroup
                                            required
                                            validationKey="agreementAccepted"
                                            errors={this.state.errors}
                                        >
                                            <Checkbox
                                                className="inline required"
                                                name="agreementAccepted"
                                                id="order.agreementAccepted"
                                                checked={this.state.order.agreementAccepted}
                                                onChange={this.formInputChangeHandler.onChange}
                                            >
                                                <span>
                                                    {Translate(
                                                        'orders/create/form/input-label/agreement-accepted'
                                                    )}
                                                </span>
                                            </Checkbox>
                                            <span
                                                className="view-agreement"
                                                onClick={() => this.openBrokerAgreementModal()}
                                            >
                                                {Translate(
                                                    'orders/create/form/input-label/view-agreement'
                                                )}
                                            </span>
                                        </ValidatableFormGroup>
                                        <Button
                                            bsSize="large"
                                            disabled={!this.canPlaceOrder()}
                                            className="create-order-button"
                                            onClick={handleOnClickCreateOrder}
                                            bsStyle="success"
                                        >
                                            {this.getCreateOrderButtonLabel(bookingType)}
                                        </Button>
                                    </Col>
                                </Row>
                            </Panel.Body>
                        </Panel>
                    )}
                </PanelGroup>
                {this.state.showAgreementModal && this.renderAgreement()}
                <Loader loaded={this.state.loaded} scale={2.0} />
                <div className={'order-loader' + (this.state.loaded ? '' : ' loader-on')} />
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        newOrder: state.orders.create.newOrder,
        user: state.user,
        orderId: state.orders.orderId,
        brokerAgreementKey: state.orders.create.newOrder.brokerAgreementKey,
        planOnlyBrokerAgreementKey: state.orders.create.newOrder.planOnlyBrokerAgreementKey,
        ownerAgreementKey: state.orders.create.newOrder.ownerAgreementKey
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            cloneOrder: (orderId: number) => dispatch(actions.cloneOrder(orderId)),
            getAvailableProducts: (firmId: number) => dispatch(actions.newOrderProducts(firmId)),
            createOrder: (
                order: ICreateOrder,
                orderCollectionId?: number,
                onlyValidate: boolean = false
            ) => dispatch(actions.createOrder(order, orderCollectionId, onlyValidate)),
            saveOrderCommandForBooking: (orderCommand: any) =>
                dispatch(actions.saveOrderCommandForBooking(orderCommand)),
            saveAddressPointLocationForBooking: (addressPointLocation: ICoordinate) =>
                dispatch(bookingActions.saveAddressPointLocationForBooking(addressPointLocation)),
            clearAddressPointLocationForBooking: () =>
                dispatch(bookingActions.clearAddressPointLocationFroBooking())
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CloneOrderPage));
